import {matchPath} from "react-router";
import * as pathToRegexp from "path-to-regexp";

import {prefixPath} from "@pg-mono/prefix-path";

import {FavoriteId, PropertyRpId} from "./types/ids";
import {SiteSlug} from "./types/site_slug";

export const kmAppPath = prefixPath("/", {
    base: "",
    logout: "logout/",
    site: prefixPath(":site([\\w-]+)/", {
        base: "",
        dashboard: prefixPath("dashboard/", {
            base: "",
            detail: ":propertyId([0-9]+)/"
        }),
        landingPage: prefixPath("", {
            createAccount: "nowe-konto/"
        }),
        messages: prefixPath("wiadomosci/", {
            base: ""
        }),
        offers: prefixPath("oferty/", {
            base: "",
            favourites: prefixPath("ulubione/", {
                base: "",
                comparator: "porownywarka/",
                comparatorDetail: "porownywarka/:propertyId([0-9]+)/",
                detail: ":propertyId([0-9]+)/"
            }),
            myInquiries: prefixPath("moje-zapytania/", {
                base: "",
                detail: ":propertyId([0-9]+)/"
            }),
            dismissed: prefixPath("odrzucone/", {
                base: "",
                detail: ":propertyId([0-9]+)/"
            }),
            recommended: prefixPath("polecane/", {
                detail: ":propertyId([0-9]+)/"
            }),
            messages: "wiadomosci/"
        }),
        passwordChange: prefixPath("przypomnij-haslo/", {
            base: "",
            link: ":token([\\w-]+)/"
        }),
        remindPassword: prefixPath("przypomnij-haslo/", {
            base: "",
            link: ":token([\\w-]+)/"
        }),
        unsubscribe: prefixPath("unsubscribe/", {
            cpl: "cpl/:uuid/",
            mailing: "mailing/:emailHash/:verificationHash/"
        }),
        user: prefixPath("konto/", {
            base: "",
            edit: "edycja/",
            passwordChange: "zmien-haslo/",
            subscription: "subskrypcje/",
            marketingConsent: "zgody-marketingowe/",
            preferences: "preferencje/",
            test: "test/"
        })
    }),
    unsubscribeHM: "unsubscribe/hm/:login_token/"
} as const);

export const kmAppLink = {
    logout: noParamsLink(kmAppPath.logout), // logout is handled on backend, routed with ingress
    site: {
        base: noParamsLink(kmAppPath.site.base),
        baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.base),
        dashboard: parseParams<{site: SiteSlug}>(kmAppPath.site.dashboard.base),
        dashboardDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId | FavoriteId}>(kmAppPath.site.dashboard.detail),
        messages: parseParams<{site: SiteSlug}>(kmAppPath.site.messages.base),
        offers: {
            base: noParamsLink(kmAppPath.site.offers.base),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.base),
            favouritesWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.favourites.base),
            favouritesComparatorWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.favourites.comparator),
            favouritesComparatorDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId}>(kmAppPath.site.offers.favourites.comparatorDetail),
            favouritesDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId | FavoriteId}>(kmAppPath.site.offers.favourites.detail),
            myInquiriesWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.myInquiries.base),
            myInquiriesDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId}>(kmAppPath.site.offers.myInquiries.detail),
            dismissedWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.dismissed.base),
            dismissedDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId}>(kmAppPath.site.offers.dismissed.detail),
            recommendedDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId}>(kmAppPath.site.offers.recommended.detail)
        },
        passwordChange: {
            base: noParamsLink(kmAppPath.site.passwordChange.base),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.passwordChange.base),
            link: parseParams<{site: SiteSlug; token: string}>(kmAppPath.site.passwordChange.link)
        },
        remindPassword: {
            base: noParamsLink(kmAppPath.site.passwordChange.base),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.remindPassword.base),
            link: parseParams<{site: SiteSlug; token: string}>(kmAppPath.site.remindPassword.link)
        },
        user: {
            base: noParamsLink(kmAppPath.site.user.edit),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.edit),
            edit: noParamsLink(kmAppPath.site.user.edit),
            editWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.edit),
            passwordChange: noParamsLink(kmAppPath.site.user.passwordChange),
            passwordChangeWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.passwordChange),
            subscription: noParamsLink(kmAppPath.site.user.subscription),
            subscriptionWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.subscription),
            marketingConsent: noParamsLink(kmAppPath.site.user.marketingConsent),
            marketingConsentWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.marketingConsent),
            preferencesWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.preferences)
        }
    }
};

function parseParams<T extends {}>(path: string) {
    const compiler = pathToRegexp.compile(path);
    return (params: T) => compiler(params);
}

function noParamsLink(path: string) {
    const compiler = pathToRegexp.compile(path);
    return () => {
        const matchedSite = matchPath<{site: SiteSlug}>(window.location.pathname, {path: kmAppPath.site.base})?.params.site;
        return compiler({site: matchedSite});
    };
}
import {matchPath} from "react-router";
import * as pathToRegexp from "path-to-regexp";

import {prefixPath} from "@pg-mono/prefix-path";

import {FavoriteId, PropertyRpId} from "./types/ids";
import {SiteSlug} from "./types/site_slug";

export const kmAppPath = prefixPath("/", {
    base: "",
    logout: "logout/",
    site: prefixPath(":site([\\w-]+)/", {
        base: "",
        dashboard: prefixPath("dashboard/", {
            base: "",
            detail: ":propertyId([0-9]+)/"
        }),
        landingPage: prefixPath("", {
            createAccount: "nowe-konto/"
        }),
        messages: prefixPath("wiadomosci/", {
            base: ""
        }),
        offers: prefixPath("oferty/", {
            base: "",
            favourites: prefixPath("ulubione/", {
                base: "",
                comparator: "porownywarka/",
                comparatorDetail: "porownywarka/:propertyId([0-9]+)/",
                detail: ":propertyId([0-9]+)/"
            }),
            myInquiries: prefixPath("moje-zapytania/", {
                base: "",
                detail: ":propertyId([0-9]+)/"
            }),
            dismissed: prefixPath("odrzucone/", {
                base: "",
                detail: ":propertyId([0-9]+)/"
            }),
            recommended: prefixPath("polecane/", {
                detail: ":propertyId([0-9]+)/"
            }),
            messages: "wiadomosci/"
        }),
        passwordChange: prefixPath("przypomnij-haslo/", {
            base: "",
            link: ":token([\\w-]+)/"
        }),
        remindPassword: prefixPath("przypomnij-haslo/", {
            base: "",
            link: ":token([\\w-]+)/"
        }),
        unsubscribe: prefixPath("unsubscribe/", {
            cpl: "cpl/:uuid/",
            mailing: "mailing/:emailHash/:verificationHash/"
        }),
        user: prefixPath("konto/", {
            base: "",
            edit: "edycja/",
            passwordChange: "zmien-haslo/",
            subscription: "subskrypcje/",
            marketingConsent: "zgody-marketingowe/",
            preferences: "preferencje/",
            test: "test/"
        })
    }),
    unsubscribeHM: "unsubscribe/hm/:login_token/"
} as const);

export const kmAppLink = {
    logout: noParamsLink(kmAppPath.logout), // logout is handled on backend, routed with ingress
    site: {
        base: noParamsLink(kmAppPath.site.base),
        baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.base),
        dashboard: parseParams<{site: SiteSlug}>(kmAppPath.site.dashboard.base),
        dashboardDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId | FavoriteId}>(kmAppPath.site.dashboard.detail),
        messages: parseParams<{site: SiteSlug}>(kmAppPath.site.messages.base),
        offers: {
            base: noParamsLink(kmAppPath.site.offers.base),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.base),
            favouritesWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.favourites.base),
            favouritesComparatorWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.favourites.comparator),
            favouritesComparatorDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId}>(kmAppPath.site.offers.favourites.comparatorDetail),
            favouritesDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId | FavoriteId}>(kmAppPath.site.offers.favourites.detail),
            myInquiriesWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.myInquiries.base),
            myInquiriesDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId}>(kmAppPath.site.offers.myInquiries.detail),
            dismissedWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.offers.dismissed.base),
            dismissedDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId}>(kmAppPath.site.offers.dismissed.detail),
            recommendedDetailWithParams: parseParams<{site: SiteSlug; propertyId: PropertyRpId}>(kmAppPath.site.offers.recommended.detail)
        },
        passwordChange: {
            base: noParamsLink(kmAppPath.site.passwordChange.base),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.passwordChange.base),
            link: parseParams<{site: SiteSlug; token: string}>(kmAppPath.site.passwordChange.link)
        },
        remindPassword: {
            base: noParamsLink(kmAppPath.site.passwordChange.base),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.remindPassword.base),
            link: parseParams<{site: SiteSlug; token: string}>(kmAppPath.site.remindPassword.link)
        },
        user: {
            base: noParamsLink(kmAppPath.site.user.edit),
            baseWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.edit),
            edit: noParamsLink(kmAppPath.site.user.edit),
            editWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.edit),
            passwordChange: noParamsLink(kmAppPath.site.user.passwordChange),
            passwordChangeWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.passwordChange),
            subscription: noParamsLink(kmAppPath.site.user.subscription),
            subscriptionWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.subscription),
            marketingConsent: noParamsLink(kmAppPath.site.user.marketingConsent),
            marketingConsentWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.marketingConsent),
            preferencesWithParams: parseParams<{site: SiteSlug}>(kmAppPath.site.user.preferences)
        }
    }
};

function parseParams<T extends {}>(path: string) {
    const compiler = pathToRegexp.compile(path);
    return (params: T) => compiler(params);
}

function noParamsLink(path: string) {
    const compiler = pathToRegexp.compile(path);
    return () => {
        const matchedSite = matchPath<{site: SiteSlug}>(window.location.pathname, {path: kmAppPath.site.base})?.params.site;
        return compiler({site: matchedSite});
    };
}
